import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=d694a864&"
import script from "./event-list.vue?vue&type=script&lang=ts&"
export * from "./event-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports